import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { homeForUser } from '@/config/navigation';

/**
 * Smart index redirect — sends each user to their tier-appropriate home.
 * PLATFORM_ADMIN → bounced out to the platform control-plane app
 * (no operational scope of their own). Everyone else → /dashboard.
 */
export function HomeRedirect() {
  const me = useCurrentUser();
  return <Navigate to={homeForUser(me)} replace />;
}
